import type { ReactNode } from "react";
import clsx from "clsx";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  /** Kompakte Variante für kleinere Karten/Seitenleisten. */
  compact?: boolean;
  className?: string;
}

/**
 * Einheitlicher Leerzustand für Listen und Karten: Icon, kurze Überschrift,
 * optionale Erklärung und eine Handlungsaufforderung.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  compact = false,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={clsx(
        "flex flex-col items-center justify-center rounded-ios border border-dashed border-separator bg-fill-quaternary/40 text-center",
        compact ? "px-4 py-6" : "px-6 py-10",
        className,
      )}
    >
      {icon ? (
        <div
          className={clsx(
            "flex items-center justify-center rounded-full bg-fill-tertiary text-label-secondary",
            compact ? "h-9 w-9 [&>svg]:h-4 [&>svg]:w-4" : "h-12 w-12 [&>svg]:h-6 [&>svg]:w-6",
          )}
          aria-hidden
        >
          {icon}
        </div>
      ) : null}
      <p className={clsx("font-semibold text-label", icon && "mt-3", compact ? "text-sm" : "text-base")}>
        {title}
      </p>
      {description ? (
        <p className="mt-1 max-w-md text-sm text-label-secondary">{description}</p>
      ) : null}
      {action ? <div className="mt-4 flex flex-wrap justify-center gap-2">{action}</div> : null}
    </div>
  );
}
